import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useLocation } from 'react-router-dom'
import { getCasinoGamesList } from 'redux-thunk/thunk/game.thunk'
import { getGameSetting } from 'redux-thunk/thunk/gameSetting'
import { setGamesList, setShowAllFavGames } from 'redux-thunk/redux/slices/games.slice'
import { setGameCategory, setProvider, setSearchGame, setTab } from 'redux-thunk/redux/slices/lobby.slice'
import { getAuthToken } from 'helpers/cookie.helpers'
import SearchBar from './components/SearchBar/index'
import GamesBar from './components/GamesBar/index'
import Lobby from './components/Lobby/index'
import OriginalsGames from './components/Lobby/Components/OriginalsGames/index'
import AllGames from './components/AllGames/index'
import LiveWins from 'pages/Home/components/LiveWins/index'
import { CASINO_TABS } from 'constants/index'
import CasinoBanner from './components/CasinoBanner/index'
import './casino.scss'

const Casino = () => {
  const dispatch = useDispatch()
  const { gameCategory: dynamicGameCategory } = useParams()
  const location = useLocation()
  const isLoggedIn = getAuthToken()
  const { tab } = useSelector(state => state?.lobby)
  const { casinoCategoriesList, showAllFavGames, categoryWiseGamesList } = useSelector((state) => state.games)
  const { user } = useSelector(state => state.user)

  const navRef = useRef()
  const firstRender = useRef(true)

  const fetchCategoryWiseGamesList = () => {
    if (isLoggedIn) {
      user && casinoCategoriesList?.slice(0, 5)?.map(({ gameCategory }) => {
        dispatch(getCasinoGamesList({ data: { offset: 0, limit: 12, type: gameCategory, userId: user?.id } }))
        return null
      })
    } else {
      casinoCategoriesList?.slice(0, 5)?.map(({ gameCategory }) => {
        dispatch(getCasinoGamesList({ data: { offset: 0, limit: 12, type: gameCategory } }))
        return null
      })
    }
  }

  useEffect(() => {
    if (dynamicGameCategory) {
      showAllFavGames && dispatch(setShowAllFavGames(false))
      dispatch(setTab('game-search'))
      dispatch(setGameCategory(dynamicGameCategory))
      dispatch(setProvider(''))
    } else {
      showAllFavGames && dispatch(setShowAllFavGames(false))
      // dispatch(setTab('lobby'))
      dispatch(setGameCategory(''))
      dispatch(setProvider(''))
    }
    // if (isLoggedIn) {
    //   dispatch(getUsersCasinoTransactions({ limit: 10, offset: 0, userId: user?.id }))
    // }
  }, [])

  useEffect(() => {
    dispatch(getGameSetting())
    window.scrollTo(0, 0)
    // window.addEventListener('scroll', toggleVisible)

    return () => {
      // window.removeEventListener('scroll', toggleVisible)
      dispatch(setGamesList([]))
      dispatch(setShowAllFavGames(false))
    }
  }, [])

  useEffect(() => {
    if (showAllFavGames) {
      dispatch(setTab('game-search'))
      dispatch(setSearchGame(''))
      dispatch(setGameCategory('favourite'))
      dispatch(setProvider(''))
    }
  }, [showAllFavGames])

  useEffect(() => {
    dispatch(setGamesList([]))
    if (casinoCategoriesList && !(location.pathname.match('/casino/group'))) {
      fetchCategoryWiseGamesList()
    }
  }, [user?.id, casinoCategoriesList])

  useEffect(() => {
    if (!firstRender.current && (tab === CASINO_TABS.LOBBY) && (categoryWiseGamesList?.length <= 0)) {
      fetchCategoryWiseGamesList()
    }
    firstRender.current = false
  }, [tab])

  // const toggleVisible = () => {
  //   const scrolled = document.documentElement.scrollTop
  //   if (scrolled > 500) {
  //     // setShowScrollBtn(true)
  //   } else if (scrolled <= 500) {
  //     // setShowScrollBtn(false)
  //   }
  // }

  return (
    <>
      <CasinoBanner />
      <LiveWins />
      <SearchBar />
      <GamesBar />
      <section className='section-space'>
        <div className='tab-content'>
          <div
            className={`tab-pane fade show ${tab === 'lobby' ? 'active' : ''}`}
            id='lobby'
            role='tabpanel'
          >
            <Lobby />
          </div>
          {tab === 'game-search' &&
            <div
              className={`tab-pane fade ${tab === 'game-search' ? 'show active' : ''}`}
              id='game-search'
              role='tabpanel'
              ref={navRef}
            >
              <AllGames navRef={navRef} />
            </div>}
          <div
            className={`tab-pane fade ${tab === 'originals' ? 'show active' : ''}`}
            id='viva-originals'
            role='tabpanel'
          >
            <OriginalsGames navRef={navRef} />
          </div>
        </div>
      </section>
    </>
  )
}

export default Casino
